import React from 'react';
import PropTypes, { any } from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import PickleballRatingFilter from './FilterComponents/PickleballRatingFilter';

import styles from '../search.scss';
import { ratingTypes } from '../../../utils/constants';

const FILTER_NAME = 'utrp';
const ratingMin = 1;
const ratingMax = 10;

const UtrpFilter = (props) => {
    const { type = '', filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const isActive =
      filters?.ratingMin !== ratingMin ||
      filters?.ratingMax !== ratingMax ||
      filterModal === FILTER_NAME;

    const handleOnRatingChange = (range) => {
        handleFilterUpdate({
          ratingMin: range[0],
          ratingMax: range[1],
        });
    };

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={FILTER_NAME}
                handleFilterClick={handleFilterClick}
                isActive={isActive}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                searchFor={type}
                data-testid={dataTestId}
            >
                {ratingTypes.pickleball}
            </Filter>
            {filterModal === FILTER_NAME && (
                <FilterModal
                    title={`${ratingTypes.pickleball} Range`}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <PickleballRatingFilter
                            filterInputs={filterInputs}
                            handleOnRatingChange={handleOnRatingChange}
                            data-testid={dataTestId && `${dataTestId}.range`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

UtrpFilter.propTypes = {
    type: PropTypes.string,
    filters: PropTypes.shape({
        ratingMin: PropTypes.number.isRequired,
        ratingMax: PropTypes.number.isRequired,
    }),
    filterInputs: PropTypes.objectOf(any),
    handleFilterClick: PropTypes.func.isRequired,
    filterModal: PropTypes.string.isRequired,
    closeModals: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

UtrpFilter.defaultProps = {
    type: '',
    filters: {
    ratingMin: 1,
    ratingMax: 10,
    },
    filterInputs: {},
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};

export default UtrpFilter;
